import React from 'react';
import '../styles/lockIconPointer.css';

const LockIconPointer = () => {
  return (
    <div className="lock-pointer-container">
      <div className="lock-pointer-arrow">⬇</div>
      <div className="lock-pointer-text">Click the 🔒 icon to enable permissions</div>
    </div>
  );
};

export default LockIconPointer;
